<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="1. Tickets & Sponsorships">
            <div>
              <AmountSelectorListTeachTalahasse />
              <ErrorLabel field="amount" />
            </div>
          </FormSection>
          <FormSection title="2. Payment Options">
            <div class="frequency">
              <PaymentOptions addSplit :splitMonths="4" />
            </div>
          </FormSection>

          <FormSection title="3. Personal Information">
            <!-- <FormRow>
              <input
                type="checkbox"
                id="student"
                name="student"
                @click="setValue('custom.student', $event.target.checked)"
              />
              <FormLabel for="student">
                Applying as a student?</FormLabel
              >
            </FormRow>
             -->
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://teachcoalition.org/privacy-policy/"/>
                  </FormRow>               
          </FormSection>
          <FormSection title="">
            <DonorAddress />
          </FormSection>
          <FormSection title="5. Payment Information" last>
            <div class="payment-info">
              <FormRow inline>
                <FormCol
                  class="doublepay"
                  field="card"
                  :showLabel="false"
                  check_text=""
                />
              </FormRow>
            </div>
          </FormSection>
          <PaymentButton showAmount btnText="Pay now" />
          <p class="note">
            <br />All donations are tax-deductible to the full extent permitted by law.
          </p>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { onMounted } from "vue";
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { setValue, form, submit } = usePaymentForm();

    if (props.subCampaign) {
      setValue("applications.0.subCampaign", props.subCampaign);
    }

    if (props.campaign) {
      setValue("applications.0.campaign", props.campaign);
    }

    onMounted(() => {
      const params = queryParams();

      if (params.utm_content) {
        if (
          !["Direct Mail", "Telemarketing", "Text SMS Message"].includes(
            params.utm_content
          )
        ) {
          throw new Error("Invalid subcampaign");
        }

        setValue("applications.0.subCampaign", params.utm_content);
      }
    });

    return {
      form,
      setValue,
      submit,
    };
  },
});
</script>
<style scoped lang="scss">
.form-container.ou-donation-form {
  margin: 0px;
  padding: 0px;
  box-shadow: none;
  max-width: 100%;
}
h2 {
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 0px;
  font-size: 20px;
  color: black;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.note {
  font-style: italic;
  line-height: 1.4;
  font-weight: bold;
  font-size: 14px;

  a {
    text-decoration: none;
  }
}
::v-deep .amount-row {
  min-width: 31.3333% !important;
  max-width: 31.3333% !important;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  // gap: 0px 25px;
  label {
    font-weight: 500;
    background: #0c3450 !important;
    color: white !important;
  }
  input[type="radio"]:checked + label {
    background: #be9e5f !important;
  }
  .amount-row{
    @media (max-width: 500px) {
    min-width: 100% !important;
    max-width: 100% !important;
    }
  }
  .amount_other__wrapper.amount-row{

  }
  .label-description {
    background: none !important;
    display: flex !important;
    flex-flow: column !important;
    align-items: center !important;
    text-align: center !important;
    font-size: 17px;
    font-style: italic;
    padding-top: 0;
    color: white !important;
    > span {
      font-size: 15px;
      font-style: italic;
    }
  }
  .label-amount {
    background: none !important;
    display: block !important;
    height: auto !important;
    max-width: 100%;
    min-width: 100% !important;
    border: none !important;
    font-size: 18px;
    text-align: center;
  }
  .amount_other__wrapper::before {
    background: #0c3450 !important;
    color: white !important;
    font-weight: bold;
  }
}

.waiver-container {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 20px;
  background-color: #fafafa;
  margin-bottom: 20px;
  p,
  ul,
  ol,
  h2 {
    margin-bottom: 20px;
    line-height: 1.5;
    font-size: 14px;
  }
  li {
    margin-bottom: 5px;
  }
  label {
    font-size: 14px;
    min-width: 150px;
    color: #222;
  }
}

// ::v-deep .error-label {
//   position: relative;
// }

label.media-label {
  flex: 1;
  margin-bottom: 5px;
  max-width: 150px;
  padding-top: 3px;
  padding-bottom: 3px;
  display: block;
}

input#student {
    margin-right: 6px;
}
</style>
